import { render, staticRenderFns } from "./videoArticle.vue?vue&type=template&id=1bab4948&scoped=true"
import script from "./videoArticle.vue?vue&type=script&lang=js"
export * from "./videoArticle.vue?vue&type=script&lang=js"
import style0 from "./videoArticle.vue?vue&type=style&index=0&id=1bab4948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bab4948",
  null
  
)

export default component.exports